
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Header, Loader, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from 'semantic-ui-react'
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';

interface hchours {
  workid:number,
  date:string,
  cluster_Name:string,
  emp_id:string,
  emp_Name:string,
  working_hours:string,
  extra_hours:string,
  title_code:string,
  action_status:string,
  }

const HCDelayUpdate = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [loadData,setLoadData]=useState<hchours[]>([]);
  const currentDate = new Date();
  const nextDay = new Date();
 const [fromDate,setFromDate]=useState<Date>(currentDate);
 const [toDate,setToDate]=useState<Date>(currentDate);
 //const [pageCount,setPageCount]=useState<number>(0);
// const [activePage, setActivePage] = useState<number>(1);
 //let pageSize=20;
 const setData=async ()=>{
  try{
    
    setLoading(true);
    // PageCount();
    const response = await axios.get("/Hour/autoHoursUpdateAPI", {
      params: {
        FromDate:fromDate,
        EndDate: toDate,
        //Page
      }
    });
    setLoadData(response.data);
    setLoading(false)
  }
  catch{
    setLoading(false)
  }
 }

//  const PageCount=async ()=>{
//   const response = await axios.get("/Hour/autoHoursUpdateAPICount", {
//     params: {
//       FromDate:fromDate,
//       EndDate: toDate,
//       //Page
//     }});
//     setPageCount(response.data/pageSize);
//  }
 const setDate=(date: Date,type: string)=>{
 
     try {
   
       if (type === 'fromDate') {
        setFromDate(date);
        nextDay.setDate(nextDay.getDate() + 1);

        setToDate(nextDay);
       } 
       if (type === 'toDate') {
        setToDate(date);
       }
      
   } catch (error) {
       toast.error('Error fetching Date');
   }
    }
  useEffect(()=>{
    setData();
    // eslint-disable-next-line
  },[])
   // const handlePageClick = (page: number) => {
  //  // setActivePage(page);
  //   // call your data load logic here
  //   console.log(`Page clicked: ${page}`);
  // };
  return (
    <>
    <div className='title_wise_cutlistreport'>
      <div>
      <Header>Hour Delay Update Employee Details</Header>
      </div>
      <div>
      {/* <div style={{ display: 'flex', alignItems: 'left', gap: '12px' }}>
                <label className='label-margin'>Date</label>
                <DatePicker selected={fromDate} onChange={(date:Date)=>setDate(date,'fromDate')} className="date-picker-style" />
                {/* <label className='label-margin'>To Date</label>
                <DatePicker selected={toDate} onChange={(date:Date)=>setDate(date,'toDate')} className="date-picker-style"/> */}
                {/* <Button onClick={setData}>Submit</Button> */}
      {/* </div> */} 
      <div style={{ display: 'inline-flex', alignItems: 'center', columnGap: '10px' }}>
            <label style={{ marginRight: '0' }}>Date</label>
            <DatePicker
              selected={fromDate}
              onChange={(date: Date) => setDate(date, 'fromDate')}
              className="date-picker-style"
            />
            <Button onClick={setData} primary>Submit</Button>
      </div>
      </div>
      <div style={{ maxHeight: '75vh', overflowY: 'auto' }}>
        <br/>
      <Table celled>
        <TableHeader style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
            <TableRow>
                <TableHeaderCell>Date</TableHeaderCell>
                <TableHeaderCell>Cluster Name</TableHeaderCell>
                <TableHeaderCell>Emp Id</TableHeaderCell>
                <TableHeaderCell>Emp Name</TableHeaderCell>
                <TableHeaderCell>Working Hours</TableHeaderCell>
                <TableHeaderCell>Extra Hours</TableHeaderCell>
                <TableHeaderCell>Title Code</TableHeaderCell>
                <TableHeaderCell>Action Status</TableHeaderCell>
            </TableRow>
       </TableHeader>
       <TableBody>
        {loadData.length > 0 && !loading ? (
          loadData.map((data,rowIndex)=> (
            <TableRow key={rowIndex}>
              <TableCell>{data.date}</TableCell>
              <TableCell>{data.cluster_Name}</TableCell>
              <TableCell>{data.emp_id}</TableCell>
              <TableCell>{data.emp_Name}</TableCell>
              <TableCell>{data.working_hours}</TableCell>
              <TableCell>{data.extra_hours}</TableCell>
              <TableCell>{data.title_code}</TableCell>
              <TableCell>{data.action_status}</TableCell>
            </TableRow>
            ))):!loading && loadData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} textAlign='center'> No data found.</TableCell>
              </TableRow>
            ):(<TableRow>
              <TableCell colSpan={8} textAlign='center'> <Loader active inline='centered' > Loading </Loader> </TableCell>
            </TableRow>)}     
       </TableBody>
      </Table>
      </div>
      <div>
      <div>
      {/* <Menu pagination>
  {Array.from({ length: pageCount  }, (_, i) => (
    <Menu.Item
      as="a"
      key={i + 1}
      active={activePage === i + 1}
      onClick={() => handlePageClick(i + 1)}
    >
      {i + 1}
    </Menu.Item>
  ))}
</Menu> */}
    </div>
      </div>
   </div>
    </>
    
  )
}

export default HCDelayUpdate